import { Component, OnInit } from '@angular/core';
import { FirebaseListObservable } from 'angularfire2/database';

import { User } from '../models/user';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {

  companies$?: FirebaseListObservable<User[]>;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.companies$ = this.userService.getUsers({
      orderByChild: User.PropertyKey.roleIsCompany,
      equalTo: true,
    });
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/companies/companies.component.ts